import { ApolloClient, InMemoryCache } from '@apollo/client';

export const IS_TESTING_ENVIRONMENT =
  // running the code locally
  // process.env.NODE_ENV === 'development' ||
  // test pages
  !!window.location.hostname?.startsWith?.('oneaudi-feature-app') ||
  // query parameter
  new URLSearchParams(window.location.search).get('environment') === 'development';

export const IS_LOCAL_ENV = !!window.location.hostname?.startsWith?.('localhost');

export const IS_LOCAL_TIER3_ENV =
  !!new URLSearchParams(window.location.search).get('ist3') === true;

export const GRAPHQL_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://qa-api.audiusa.com/graphql'
  : 'https://api.audiusa.com/graphql';

export const ONE_GRAPH_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://int.onegraph.audi.com/graphql'
  : 'https://onegraph.audi.com/graphql';

// Temp solution to see T3 UI/UX
export const IS_T3_WEBSITE = new URLSearchParams(window.location.search).get('ist3') === 'true';

const windowLocation = typeof window !== 'undefined' ? window.location : undefined;

export const RAW_PARTNER_ID =
  new URLSearchParams(windowLocation?.search).get('partner_id') ?? undefined;

export const PARTNER_ID =
  RAW_PARTNER_ID && RAW_PARTNER_ID.length > 5 ? RAW_PARTNER_ID.slice(1) : RAW_PARTNER_ID;

export const ONDEMAND_CAROUSEL_GALLERY = new URLSearchParams(window.location.search).has(
  'lazyLoadGallery',
);

export const oneGraphClient = new ApolloClient({
  uri: ONE_GRAPH_GATEWAY_URL,
  cache: new InMemoryCache(),
  // defaultOptions,
  name: __FEATURE_APP_NAME__,
  version: __FEATURE_APP_VERSION__,
});

export const OADD_DEALERS_JSON = IS_TESTING_ENVIRONMENT
  ? 'https://fa-vlp-list-page.cdn.dev.collab.apps.one.audi/t3dealers.json'
  : 'https://fa-vlp-list-page.cdn.prod.collab.apps.one.audi/t3dealers.json';

export const FrenchOaddDealers = [
  '95212',
  '94834',
  '94831',
  '94827',
  '94826',
  '94817',
  '94816',
  '94801',
  '94796',
  '94794',
  '94757',
  '94753',
  '94708',
  '93252',
  '93250',
];
